/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_AudioInputs */

const en_pricing_feature_audio = /** @type {(inputs: Pricing_Feature_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text, PDFs, and articles to audio`)
};

const es_pricing_feature_audio = /** @type {(inputs: Pricing_Feature_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte texto, PDF y artículos en audio`)
};

/**
* | output |
* | --- |
* | "Text, PDFs, and articles to audio" |
*
* @param {Pricing_Feature_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_audio = /** @type {((inputs?: Pricing_Feature_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_feature_audio(inputs)
	return en_pricing_feature_audio(inputs)
});